// extracted by mini-css-extract-plugin
export default {"btn":"PerfonalInfoForm_btn__9e7GR","btn-success":"PerfonalInfoForm_btn-success__eDt9C","heading":"PerfonalInfoForm_heading__MStUq"};